import { USER_ACTION_TYPES, CLEAR_USER } from 'utils/actions/user'

const defaultState = {
  isFetching: false,
  error: null,
  userDetails: {},
  userPermissions: {},
  shipmentPermissions: {},
}

const { USER_FAILURE, USER_REQUEST, USER_SUCCESS } = USER_ACTION_TYPES

const userMetaReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case USER_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      }
    case USER_SUCCESS: {
      const {
        payload: { shipmentPermissions, user, userPermissions },
      } = action
      return {
        ...state,
        isFetching: false,
        error: null,
        userDetails: user || {},
        userPermissions: userPermissions || {},
        shipmentPermissions: shipmentPermissions || {},
      }
    }
    case USER_FAILURE: {
      const { error } = action
      return {
        ...state,
        isFetching: false,
        error,
      }
    }
    case CLEAR_USER: {
      return defaultState
    }
    default:
      return state
  }
}

export default userMetaReducer
